import axios from "axios";
import qs from "qs";
import router from "../router/index";
import store from "../store/index";
import {handleBlobFile } from "../utils/utils";
import mockUrls from "../config/mockUrl";


const CommonHeaderEnum ={
	'TENANT_ID' : 'TENANT-ID',
	'ENC_FLAG' : 'Enc-Flag',
	'AUTHORIZATION' : 'Authorization',
	'MICRO_TWT' : 'microjwt'
}

function getToken(){
  return window.sessionStorage.getItem("token")
}
// axios interceptors
// 同一时间有多个请求时，会形成队列。在第一个请求创建loading，在最后一个响应关闭loading
var queue = [];
//当有一个错误弹窗打开时不会再打开第二个
var openWin = false;
var _token = null;
function getLastPart(str) {
  var parts = str.split('/');
  return parts[parts.length - 1];
}
axios.interceptors.request.use(
  config => {
    const mockBaseURL = process.env.VUE_APP_MOCK_BASE_URL || "";

    if (mockUrls.shouldMock(config.url, config.method)) {
      config.baseURL = mockBaseURL;
    } else {
      config.baseURL = config.baseURL == "" ? "" : process.env.VUE_APP_BASE_API;
    }
    config.timeout = 3600*1000;
    return config;
  },
  error => {
    // 关闭loading提示
    // 继发连续请求，延时处理是为防止多个loading实例闪屏。
    setTimeout(() => {
      queue.shift();
      if (!queue.length) {
        store.commit("SET_SHOW_LOADING", false);
      }
    }, 30);
    return Promise.reject(error);
  }
);
axios.interceptors.response.use(
  response => {
    // 关闭loading提示
    setTimeout(() => {
      queue.shift();
      if (!queue.length) {
        store.commit("SET_SHOW_LOADING", false);
      }
    }, 100);
    return response;
  },
  error => {
    // 关闭loading提示
    setTimeout(() => {
      queue.shift();
      if (!queue.length) {
        store.commit("SET_SHOW_LOADING", false);
      }
    }, 100);
    return Promise.reject(error);
  }
);

const isObject = v => {
  return Object.prototype.toString.call(v) === "[object Object]";
};

//http request with loading
const http = function (url, params, method, header) {
  // 显示loading提示
  if (store.state.loading) {
    queue.push(1);
  }
  if (queue.length > 0) {
    store.commit("SET_SHOW_LOADING", true);
  }
  let p =
    params != undefined && params != null && isObject(params)
      ? qs.stringify(params)
      : params;
  if (!header) {
    header = {};
  }
  if (!header["Content-Type"]) {
    header = {
      ...header,
      // "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      "Content-Type": "application/json;charset=UTF-8",
    };
  }
  if(header.isQs){
    header = {
      ...header,
      "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
    };
  }

  header[CommonHeaderEnum.AUTHORIZATION] = `Bearer ${getToken()}`;
  let requestObj = null;
  if ("GET" == method) {
    requestObj = {
      url:  url,
      method: method,
      params: params,
      headers: header,
    };
  } else if ("download" == method) {
    requestObj = {
      url: url,
      method: "GET",
      params: params,
      headers: {...header, responseType: "blob"},
    };
  } else {
    requestObj = {
      url:  url,
      method: method,
      data: !header.isQs ? params : p,
      // data:  params ,
      headers: header,
    };
  }

  return new Promise((resolve, reject) => {
    axios(requestObj)
      .then(res => {
        if ("download" == method) {
          if (res.status !== 200) {
            throw res;
          }
          if (!res) return;
          handleBlobFile(res.data, params.filename);
          return;
        }
        if (res.data.code == 0 ) {
          resolve(res.data.data);
        } else {
          let content = "";
          if (res.data.code == -100) {
            content = res.data.msg || res.data.message;
            if (!openWin) {
              openWin = true;
              window.$root.$message({
                showClose: true,
                message: content,
                type: "error",
                onClose: () => {
                  openWin = false;
                    router.push({ path: "/login" });

                },
              });
            }
          } else if (res.data.code == -101) {
            //非法字符
            content = res.data.data;
            if (!openWin) {
              openWin = true;
              window.$root.$message({
                showClose: true,
                message: content,
                type: "error",
                onClose: () => {
                  openWin = false;
                },
              });
            }
          } else {
            content = res.data.message || res.data.msg;
            console.log(isHtml(content));
            if (isHtml(content) && content) {
              window.$root.$alert(content, "提示", {
                dangerouslyUseHTMLString: true,
              });
            } else {
              if (!openWin) {
                openWin = true;
                window.$root.$message({
                  showClose: true,
                  message: content,
                  type: "error",
                  onClose: () => {
                    openWin = false;
                  },
                });
              }
            }
          }
          reject(res.data);
        }
      })
      .catch(function (error) {
        if (!openWin) {
          openWin = true;
          const ul=getLastPart(url)
          let  msg=`服务请求失败，请联系系统管理人员解决！[${ul}]`
          window.$root.$message({
            showClose: true,
            message: msg + error,
            type: "error",
            onClose: () => {
              openWin = false;
            },
          });
        }
        reject(error);
      });
  });
};

function isHtml(str) {
  const htmlTagRegex = /<[^>]+>/;
  return htmlTagRegex.test(str);
}

//http request without loading
const http_silent = function (url, params, method, header) {
  let p =
    params != undefined && params != null && isObject(params)
      ? qs.stringify(params)
      : params;
  if (!header) {
    header = {};
  }
  if (!header["Content-Type"]) {
    header = {
      ...header,
      // "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      "Content-Type": "application/json;charset=UTF-8",
    };
  }
  if(header.isQs){
    header = {
      ...header,
      "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
    };
  }
  header[CommonHeaderEnum.AUTHORIZATION] = `Bearer ${getToken()}`;
  let requestObj = null;
  if ("GET" == method) {
    requestObj = {
      url:  url,
      method: method,
      params: params,
      headers: header,
    };
  } else {
    requestObj = {
      url:  url,
      method: method,
      data: !header.isQs ? params : p,
      // data:params,
      headers: header,
    };
  }

  return new Promise((resolve, reject) => {
    axios(requestObj)
      .then(res => {
        if (res.data.code == 0 || res.data.code == 1 || res.data.code == "y") {

          resolve(res.data.data);
        } else {
          let content = "";
          if (res.data.code == -500) {
            content = res.data.msg || res.data.message;
            if (!openWin) {
              openWin = true;
              window.$root.$message({
                showClose: true,
                message: content,
                type: "error",
                onClose: () => {
                  openWin = false;
                    router.push({ path: "/login" });

                },
              });
            }
          } else if (res.data.code == -98) {
            //非法字符
            content = res.data.data;
            if (!openWin) {
              openWin = true;
              window.$root.$message({
                showClose: true,
                message: content,
                type: "error",
                onClose: () => {
                  openWin = false;
                },
              });
            }
          } else {
            content = res.data.message || res.data.msg;
            console.log(isHtml(content));
            if (isHtml(content) && content) {
              window.$root.$alert(content, "提示", {
                dangerouslyUseHTMLString: true,
              });
            } else {
              if (!openWin) {
                openWin = true;
                window.$root.$message({
                  showClose: true,
                  message: content,
                  type: "error",
                  onClose: () => {
                    openWin = false;
                  },
                });
              }
            }
          }
          reject(res.data);
        }
      })
      .catch(function (error) {
        if (!openWin) {
          openWin = true;
          const ul=getLastPart(url)
          let  msg=`服务请求失败，请联系系统管理人员解决！[${ul}]`
          window.$root.$message({
            showClose: true,
            message:  msg+ error,
            type: "error",
            onClose: () => {
              openWin = false;
            },
          });
        }
        reject(error);
      });
  });
};

export default {
  get: function (url, params, header) {
    return http(url, params, "GET", header);
  },
  post: function (url, params, header) {
    return http(url, params, "POST", header);
  },
  get_s: function (url, params, header) {
    //不带loading效果的请求
    return http_silent(url, params, "GET", header);
  },
  post_s: function (url, params, header) {
    //不带loading效果的请求
    return http_silent(url, params, "POST", header);
  },
  put: function (url, params, header) {
    return http(url, params, "PUT", header);
  },
  download: function (url, params, header) {
    return http(url, params, "download", header);
  },
};
